import React from 'react';
import Img from 'react-image';
import { TabPane } from '../../../modules/unsw-tabs';
import {
  DashboardModal,
  DashboardModalTabContent,
} from '../../../modules/unsw-modals';
import QuestionnaireResponseSidebar from '../../../containers/Modals/SupportingLink/QuestionnaireResponseSidebar';
import { Spinner } from 'reactstrap';

const Image = ({ link }: { link: string }) => (
  <Img
    src={link}
    className={'img-fluid'}
    alt="Supporting Informatic"
    loader={<Spinner />}
  />
);

const SupportingLinkModelComponent = ({
  links,
}: {
  links: { tabId: string; label: string; link: string }[];
}) => {
  return (
    <DashboardModal>
      <DashboardModalTabContent
        links={links.map(link => ({ tabId: link.tabId, label: link.label }))}>
        {links.map(link => (
          <TabPane key={link.tabId} tabId={link.tabId}>
            <Image link={link.link} />
          </TabPane>
        ))}
      </DashboardModalTabContent>
      <QuestionnaireResponseSidebar />
    </DashboardModal>
  );
};
export default SupportingLinkModelComponent;
